<template>
  <div class="content">
    <van-row style="text-align: center;border:.01rem solid #dedede;background-color: #fff;line-height: .8rem;font-size: .24rem;font-weight: bold;">
      <van-col :span="12" style="border-right: .01rem solid #dedede;" @click="index=1;" :class="index==1?'on':''">常见问题</van-col>
      <van-col :span="12" style="border-right: .01rem solid #dedede;" @click="index=2;" :class="index==2?'on':''">业务指南</van-col>
      <!-- <van-col :span="8" @click="index=3;">使用小技巧</van-col> -->
    </van-row>
    <van-row style="margin-top: .15rem;">
      <van-collapse v-model="activeNames" v-if="index==1">
        <van-collapse-item title="主叫号码或外显号码选用哪种运营商？" name="1">建议：优先使用中国移动运营商手机卡进行注册,优先级移动、联通、电信</van-collapse-item>
        <van-collapse-item title="收不到回拨电话" name="2">
          原因：主叫号码关机、停机、欠费或停用<br>
          解决方法：请确保主叫号码（外显号码）能正常接听电话
        </van-collapse-item>
        <van-collapse-item title="拨号时提示”当前号码分配其他坐席”" name="3">
          原因：您当前拨打的被叫号码被其他客服拨打过<br>
          解决方法：以管理员身份进入PC机构后台点击【机构线索库】页面，然后点击【防撞单设置】进行设置：<br>
          关闭后，一个号码只能一个客服跟进<br>
          开启后，一个号码可多个客服跟进
        </van-collapse-item>
        <van-collapse-item title="拨号时页面弹窗提示”该号码为高频呼出号码”" name="4">原因：线路直呼用户被叫号码24小时内仅限拨打一次</van-collapse-item>
        <van-collapse-item title="拨号时提示”请联系您公司管理员绑定外显号码”" name="5">
          原因：该用户未绑定坐席<br>
          解决方法：<br>
          1、在销售保APP中【办公】【坐席管理】【外显列表】新增外显,在坐席列表中进行绑定员工操作<br>
          2、以管理员账号登录机构后台，在【系统设置】【坐席管理】【外显管理】中添加外显后，再进行绑定员工操作
        </van-collapse-item>
        <van-collapse-item title="拨号时提示”线路异常,请立即联系客服人员[X]”" name="6">
          原因：线路异常，运营商线路网络波动<br>
          解决方法：请联系客服人员
        </van-collapse-item>
        <van-collapse-item title="音质延迟" name="7">
          原因：WIFI信号网络薄弱、波动、信号不稳定<br>
          解决方法：在网络、信号正常情况下通话
        </van-collapse-item>
        <van-collapse-item title="话费充值" name="8">
          1、微信关注”销售保”,点击【费用中心】【费用充值】输入手机号后进行充值<br>
          2、以管理员身份进入PC机构后台,点击【费用中心】点击充值按钮进行充值
        </van-collapse-item>
        <van-collapse-item title="销售保下载" name="10">
          1、关注”销售保”微信公众号,点击【APP下载】【销售保APP下载】在浏览器中打开进行下载<br>
          2、以管理员身份进入PC机构后台,页面右上角点击”销售保APP”扫码进行下载<br>
          3、各大应用市场下载，苹果商店下载
        </van-collapse-item>
        <van-collapse-item title="验证码登录时提示”验证码发送频繁,请稍后重试”" name="11">
          当日发送验证码超出限制，请使用密码登录或联系销售保客服
        </van-collapse-item>
      </van-collapse>
      <van-collapse v-model="activeNames" v-if="index==2">
        <van-collapse-item title="基本使用流程" name="1">
          <img src="../../assets/help/0.png" style="width: 100%;">
        </van-collapse-item>
        <van-collapse-item title="添加员工的流程图解" name="2">
          第一种方式（由管理员统一添加员工）：<br>
          以管理员身份登录机构后台，点击【系统设置】-【岗位管理】-【部门员工管理】-【添加部门】-【添加员工】,输入员工真实姓名、手机号码、密码、角色后进行创建即可<br>
          注：手机号码为员工登录APP的账号，密码为员工登录APP的密码。<br>
          第二种方式（员工以加入公司的方式自动添加为公司员工）：<br>
          员工在销售保APP选择加入公司，输入管理员手机号码和员工基本信息，即可加入公司；<br>
          <img src="../../assets/help/1.png" style="width: 100%;margin-top: .1rem;">
        </van-collapse-item>
        <van-collapse-item title="添加外显流程图解" name="3">
          <img src="../../assets/help/2.png" style="width: 100%;">
          <img src="../../assets/help/3.png" style="width: 100%;margin-top: .1rem;">
        </van-collapse-item>
        <van-collapse-item title="坐席绑定流程图解" name="4">
          选择员工，将员工关联至坐席<br>
          <img src="../../assets/help/4.png" style="width: 100%;margin-top: .1rem;">
        </van-collapse-item>
        <van-collapse-item title="机构后台导入、分配线索流程图解" name="5">
          一、导入线索-模板导入
          启用字段后自动加入到模板字段中进行下载
          <img src="../../assets/help/8.png" style="width: 100%;">
          <img src="../../assets/help/9.png" style="width: 100%;margin-top: .1rem;">
          可选导入字段列表：移除到导入模板字段中则模板字段增加;
          导入模板字段列表：移除到可选导入字段中则模板字段减少;
          <img src="../../assets/help/10.png" style="width: 100%;margin-top: .1rem;">
          二、分配线索
          导入线索之后，选择线索包，点击人工一键分配，打开分配对话框，填任务名称选择分配人员，即可按人员平均分配线索
          <img src="../../assets/help/11.png" style="width: 100%;margin-top: .1rem;">
          <img src="../../assets/help/12.png" style="width: 100%;margin-top: .1rem;">
        </van-collapse-item>
        <van-collapse-item title="拨打流程图解" name="6">
          员工在APP【线索】-【分配线索】列表进行线索拨打操作<br>
          <img src="../../assets/help/7.png" style="width: 100%;margin-top: .1rem;">
        </van-collapse-item>
        <!-- <van-collapse-item title="标题3" name="3" disabled>内容</van-collapse-item> -->
      </van-collapse>
      <van-collapse v-model="activeNames" v-if="index==3">
        <van-collapse-item title="标题1" name="1">内容</van-collapse-item>
        <van-collapse-item title="标题2" name="2">内容</van-collapse-item>
        <!-- <van-collapse-item title="标题3" name="3" disabled>内容</van-collapse-item> -->
      </van-collapse>
    </van-row>
  </div>
</template>
<script>
// import {} from '../../api';
export default {
  name: 'help',
  data() {
    return {
      index: 1,
      activeNames: []
    }
  },
  methods: {

  },
  mounted() {

  }
}
</script>
<style type="text/css">
.on {
  background-color: #3b89ff;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/app/help.vue


// WEBPACK FOOTER //
// src/views/app/help.vue